/**
 * Operator to perform on the instrument(s) specified
 * tag: 1535
 * @readonly
 * @enum {number} (int)
 */
export enum InstrumentScopeOperator {
  /** Include */
  Include = 1,
  /** Exclude */
  Exclude = 2,
}
